import { BCDataGrid, BCTag, findMessage } from '@bimser/components';
import { getDmIcon } from '../../../utilities/helpers';
import DmThumbnail from '../../DMThumbnail';

export const renderTags = (args: { value: Array<string> }) => {
	const tags = args?.value || [];

	return (
		<span title={tags.toString() || undefined}>
			{tags.map((tag: string) => (
				<BCTag
					text={tag}
					key={tag}
				/>
			))}
		</span>
	);
};

export const renderTypeIcon = (args: { value: number; row }) => {
	const defaultIcon = getDmIcon(args.value, null, args.row.data.NAME, 16);

	if (args.row.data.existThumbnail) {
		return (
			<DmThumbnail
				key={`thumbnail_${args.row.data.SECRETKEY}`}
				defaultIcon={defaultIcon}
				secretKey={args.row.data.SECRETKEY}
				iconSize={16}
			/>
		);
	}

	return defaultIcon;
};

export const typeColumn: BCDataGrid.Entities.IColumnProps = {
	name: 'TYPE',
	caption: findMessage.get('100175'),
	dataField: 'TYPE',
	dataType: 'number',
	alignment: 'center',
	visibleIndex: 0,
	allowFiltering: false,
	width: 100,
	cellRender: renderTypeIcon
};

export const IDColumn: BCDataGrid.Entities.IColumnProps = {
	name: 'ID',
	dataField: 'ID',
	dataType: 'string',
	visible: false,
	allowHiding: false,
	showInColumnChooser: false
};

export const dateTimeFilterOptions = { type: 'date', displayFormat: 'shortdate' };

export const baseDefaultColumns: Array<BCDataGrid.Entities.IColumnProps> = [
	IDColumn,
	typeColumn,
	{
		name: 'NAME',
		dataField: 'NAME',
		dataType: 'string',
		caption: findMessage.get('100021'),
		selectedFilterOperation: 'contains',
		visibleIndex: 1,
		allowHiding: false
	},
	{
		name: 'DESCRIPTION',
		dataField: 'DESCRIPTION',
		caption: findMessage.get('100022'),
		dataType: 'string',
		selectedFilterOperation: 'contains',
		visibleIndex: 2
	}
];

const defaultColumns: Array<BCDataGrid.Entities.IColumnProps> = [
	...baseDefaultColumns,
	{
		name: 'OWNER',
		dataField: 'OWNER',
		caption: findMessage.get('100176'),
		dataType: 'string',
		selectedFilterOperation: 'contains',
		visibleIndex: 3
	},
	{
		name: 'CREATEDAT',
		dataField: 'CREATEDAT',
		caption: findMessage.get('100435'),
		dataType: 'datetime',
		selectedFilterOperation: '=',
		editorOptions: dateTimeFilterOptions,
		visibleIndex: 4
	},
	{
		name: 'MODIFIEDAT',
		dataField: 'MODIFIEDAT',
		caption: findMessage.get('100881'),
		dataType: 'datetime',
		selectedFilterOperation: '=',
		editorOptions: dateTimeFilterOptions,
		visibleIndex: 5
	},
	{
		name: 'TAGS',
		dataField: 'TAGS',
		caption: findMessage.get('101036'),
		dataType: 'string',
		visibleIndex: 6,
		cellRender: renderTags,
		allowFiltering: true,
		selectedFilterOperation: 'contains'
	}
];

export default defaultColumns;
